//? import statements
import { useState, useEffect } from "react";
import "./App.css";
import Experience from "./Components/Experience/Experience";
import axios from "axios";
const uri =
  "https://course-api.com/react-tabs-project";

const App = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const { data } = await axios.get(uri);
      setData(data);
    } catch (err) {
      setHasError(true);
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <section className="container">
      <div className="header">
        <h1>Experience</h1>
        <p id="line"></p>
      </div>
      {!loading && !hasError && (
        <Experience data={data} />
      )}
      {loading && <p id="loading">loading....</p>}
      {!loading && hasError && (
        <p id="error">{error}</p>
      )}
    </section>
  );
};

export default App;
